import React from 'react';
import { BotIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function OpenclawPricing() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5517">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5518">
        <div className="max-w-5xl mx-auto" data-id="element-5519">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5520">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-5521">
              Simple pricing for your{' '}
              <span className="text-blue-600" data-id="element-5522">AI sales agent</span>
            </h2>
            <p className="text-lg text-slate-500 leading-relaxed" data-id="element-5523">
              Pay only for the successful outputs the agent generates. No
              enterprise contracts or hidden per-seat fees.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-5524">
            {/* Agent Workflows */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 flex flex-col" data-id="element-5525">
              <div className="flex items-center gap-3 mb-4" data-id="element-5526">
                <BotIcon className="w-5 h-5 text-slate-400" data-id="element-5527" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-5528">
                  Agent workflows
                </h3>
              </div>
              <p className="text-slate-600 mb-8 flex-grow" data-id="element-5529">
                Run natural language queries, score leads, and generate custom
                deliverables.
              </p>
              <div data-id="element-5530">
                <div className="flex items-baseline gap-2" data-id="element-5531">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5532">
                    Free
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5533">
                  unlimited workflows
                </p>
              </div>
            </div>

            {/* Owner Emails */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 flex flex-col relative overflow-hidden" data-id="element-5534">
              <div className="absolute top-0 inset-x-0 h-1 bg-blue-600" data-id="element-5535" />
              <div className="flex items-center gap-3 mb-4" data-id="element-5536">
                <MailIcon className="w-5 h-5 text-blue-600" data-id="element-5537" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-5538">
                  Enriched emails & drafts
                </h3>
              </div>
              <p className="text-slate-600 mb-8 flex-grow" data-id="element-5539">
                Get verified owner emails and let the agent draft personalized
                outreach.
              </p>
              <div data-id="element-5540">
                <div className="flex items-baseline gap-2" data-id="element-5541">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5542">$6</span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5543">
                  per 100 emails found
                </p>
              </div>
            </div>

            {/* Employee Phones */}
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-8 flex flex-col" data-id="element-5544">
              <div className="flex items-center gap-3 mb-4" data-id="element-5545">
                <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-5546" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-5547">
                  Direct phone numbers
                </h3>
              </div>
              <p className="text-slate-600 mb-8 flex-grow" data-id="element-5548">
                Access direct dials for multi-channel CRM sequences and cold
                calling.
              </p>
              <div data-id="element-5549">
                <div className="flex items-baseline gap-2" data-id="element-5550">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-5551">$24</span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-5552">
                  per 100 phones found
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-5553">
            <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5554">
              <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5555" />
              <span data-id="element-5556">Pay only for valid results</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5557">
              <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5558" />
              <span data-id="element-5559">Free credits to start</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-5560">
              <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-5561" />
              <span data-id="element-5562">No credit card required</span>
            </div>
          </div>

          <div className="text-center" data-id="element-5563">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-5564">
              <Button href="http://app.openmart.com/register" variant="primary" size="lg" data-id="element-5565">
                Try for free
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}